
import { lazy, Suspense, useEffect } from 'react'
import './App.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import './styles/scss/style.scss'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import {BrowserRouter,Routes, Route, useLocation} from 'react-router-dom'
import Products from './components/Products';
const SharedLayout = lazy(()=> import('./components/SharedLayout'))
const Login = lazy(()=> import('./components/Login'))
const Loginprotectedroute = lazy(()=> import( './components/Loginprotectedroute'))
const Register = lazy(()=> import( './components/Register'))
const Cart = lazy(()=> import( './components/Cart'))
const ProtectedRoute = lazy(()=> import( './components/ProtectedRoute'))
const Orderform = lazy(()=> import( './components/Orderform'))
const Shop = lazy(()=> import( './components/shop/Shop'))
const Details = lazy(()=> import( './components/productdetail/Details'))
const Branditems = lazy(()=> import( './components/shopbybrand/Branditems'))
const Profile = lazy(()=> import( './components/profile/Profile'))
const Userdata = lazy(()=> import( './components/profile/Userdata'))
const Userorder = lazy(()=> import( './components/profile/Userorder'))
const Forgotpassword = lazy(()=> import( './components/Forgotpassword'))
const Wishlistcomp = lazy(()=> import( './components/profile/Wishlistcomp'))
const Blog = lazy(()=> import( './components/blog/Blog'))
const Contact = lazy(()=> import( './components/contactus/Contact'))
const Terms = lazy(()=> import( './components/terms/Terms'))
const Aboutas = lazy(()=> import( './components/about/Aboutas'))
const Blogdetail = lazy(()=> import( './components/blog/Blogdetail'))
const Privacy = lazy(()=> import( './components/privacypolicy/Privacy'))
const Dealscomp = lazy(()=> import( './components/deals/Dealscomp'))
const Successpayement = lazy(()=> import( './components/successpage/Successpayement'))
const Faq = lazy(()=> import( './components/faq/ImoxFaq'))
function App() {
//   function RouteTracker() {
//   const location = useLocation();
//   useEffect(() => {
//     if (window.gtag) {
//       window.gtag('event', 'ads_conversion_Add_to_basket_1', {
//         page_path: location.pathname + location.search,
//       });
//     }
//   }, [location])
//   return null
// }
  return (
    <div>
      <BrowserRouter>
      <Suspense fallback={''}>
        {/* <RouteTracker /> */}
        <Routes>
          <Route path='/' element={  <SharedLayout />   }>
            <Route index element={<ProtectedRoute> <Products />  </ProtectedRoute>   } />
            <Route path='login' element={<Loginprotectedroute>  <Login /> </Loginprotectedroute>} />
            <Route path='forgotpassword' element={<Loginprotectedroute>  <Forgotpassword /> </Loginprotectedroute>} />
            <Route path='register' element={<Loginprotectedroute> <Register /> </Loginprotectedroute> } />
            <Route path='/cart' element={ <ProtectedRoute>  <Cart/> </ProtectedRoute>   } />
            <Route path='orderform' element={<ProtectedRoute>  <Orderform /> </ProtectedRoute>  } />
            <Route path='Shop' element={<ProtectedRoute> <Shop /> </ProtectedRoute> } />
            <Route path='/Profile' element={<ProtectedRoute>  <Profile /> </ProtectedRoute>} >
            <Route index path='/Profile' element={<ProtectedRoute>  <Userdata /> </ProtectedRoute>} />
            <Route path='userorders' element={<ProtectedRoute>  <Userorder /> </ProtectedRoute>} />
            <Route path='wishlists' element={<ProtectedRoute>  <Wishlistcomp /> </ProtectedRoute>} />
            </Route>
            <Route path="/product/:name/:id" element={<ProtectedRoute>  <Details /> </ProtectedRoute> } />
            <Route path="/brand" element={<ProtectedRoute>  <Branditems /> </ProtectedRoute> } />
            <Route path="/blog" element={<ProtectedRoute>  <Blog /> </ProtectedRoute> } />
            <Route path="/blog/:name" element={<ProtectedRoute>  <Blogdetail /> </ProtectedRoute> } />
            <Route path="/contact" element={ <ProtectedRoute>   <Contact /> </ProtectedRoute>  } />
            <Route path="/terms" element={<ProtectedRoute>  <Terms /> </ProtectedRoute> } />
            <Route path="/about" element={<ProtectedRoute>  <Aboutas /> </ProtectedRoute> } />
            <Route path="/privacy" element={<ProtectedRoute>  <Privacy /> </ProtectedRoute> } />
            <Route path="/deals" element={ <ProtectedRoute> <Dealscomp /> </ProtectedRoute>  } />
            <Route path="/successpage" element={<ProtectedRoute>  <Successpayement /> </ProtectedRoute> } />
            <Route path="/faq" element={ <ProtectedRoute> <Faq /> </ProtectedRoute> } />
            <Route path='*' element={<div className='text-center text-danger d-flex justify-content-center align-items-center' style={{marginTop:'250px'}}>Error Page Not Found</div>} />
          </Route> 
        </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  )
}
export default App